import React, { useState } from "react";
import Input from "../../../components/Input";
import { MdEdit } from "react-icons/md";

const EditProfile = () => {
  const [formData, setFormData] = useState({
    name: "Charlene Reed",
    username: "Charlene Reed",
    email: "charlenereed@gmail.com",
    password: "********",
    dob: "25 January 1990",
    address: "San Jose, California, USA",
    city: "San Jose",
    postalCode: "43962",
    country: "USA",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const [image, setImage] = useState("https://picsum.photos/200");

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="bg-gray-50 p-6 rounded-lg shadow-md">
      <div className="flex items-start">
        {/* Profile Image Section */}
        <div className="relative flex-shrink-0">
          <img
            src={image}
            alt="Profile"
            className="w-24 h-24 rounded-full object-cover border-4 border-white shadow-lg"
          />
          <label
            htmlFor="profileImage"
            className="absolute bottom-0 right-0 bg-blue-500 text-white p-2 rounded-full shadow-md hover:bg-blue-600 transition cursor-pointer"
            aria-label="Edit Profile Picture"
          >
            <MdEdit size={20} />
          </label>
          <input
            type="file"
            id="profileImage"
            accept="image/*"
            onChange={handleImageChange}
            className="hidden"
          />
        </div>

        {/* Form Section */}
        <div className="flex-grow ml-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Input
              label="Your Name"
              value={formData.name}
              onChange={handleChange}
              name="name"
            />
            <Input
              label="User Name"
              value={formData.username}
              onChange={handleChange}
              name="username"
            />
            <Input
              label="Email"
              value={formData.email}
              onChange={handleChange}
              name="email"
            />
            <Input
              label="Password"
              value={formData.password}
              type="password"
              onChange={handleChange}
              name="password"
            />
            <Input
              label="Date of Birth"
              value={formData.dob}
              onChange={handleChange}
              name="dob"
            />
            <Input
              label="Present Address"
              value={formData.address}
              onChange={handleChange}
              name="address"
            />
            <Input
              label="City"
              value={formData.city}
              onChange={handleChange}
              name="city"
            />
            <Input
              label="Postal Code"
              value={formData.postalCode}
              onChange={handleChange}
              name="postalCode"
            />
            <Input
              label="Country"
              value={formData.country}
              onChange={handleChange}
              name="country"
            />
          </div>

          <div className="flex justify-end mt-6">
            <button
              onClick={() => alert("Profile Updated!")}
              className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
